/* ============================================================
   MAHER — Collection page: facets (filter & sort) + infinite scroll
   ============================================================ */
(function () {
  var section = document.querySelector('[data-collection-section]');
  if (!section) return;
  var sectionId = section.getAttribute('data-section-id');
  var form = section.querySelector('[data-filters-form]');
  var content = section.querySelector('[data-collection-content]');

  /* ---- Filter drawer (overlay on narrow screens) ---- */
  var NARROW = 768;
  function openFilters() {
    if (!content) return;
    content.classList.add('filters-open');
    var t = section.querySelector('[data-filter-toggle]');
    if (t) t.setAttribute('aria-expanded', 'true');
    if (window.innerWidth <= NARROW) document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!content) return;
    content.classList.remove('filters-open');
    var t = section.querySelector('[data-filter-toggle]');
    if (t) t.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  window.closeFilters = closeFilters;

  var toggle = section.querySelector('[data-filter-toggle]');
  if (toggle) toggle.addEventListener('click', function () {
    content.classList.contains('filters-open') ? closeFilters() : openFilters();
  });
  var closeBtn = section.querySelector('[data-filter-close]');
  if (closeBtn) closeBtn.addEventListener('click', closeFilters);
  var overlay = section.querySelector('[data-filter-overlay]');
  if (overlay) overlay.addEventListener('click', closeFilters);

  /* ---- Filter group accordions ---- */
  section.querySelectorAll('.filter-group__title').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.filter-group');
      group.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', String(!group.classList.contains('is-collapsed')));
    });
  });

  /* ---- Build a filtered URL from current control state and navigate ---- */
  function applyFilters() {
    if (!form) return;
    var params = new URLSearchParams();

    form.querySelectorAll('[data-facet-checkbox]:checked').forEach(function (cb) {
      params.append(cb.name, cb.value);
    });
    form.querySelectorAll('[data-facet-price]').forEach(function (inp) {
      if (inp.value !== '') params.set(inp.name, inp.value);
    });
    section.querySelectorAll('.filter-colour-swatch.is-selected').forEach(function (sw) {
      params.append(sw.getAttribute('data-facet-name'), sw.getAttribute('data-facet-value'));
    });
    var sortInput = form.querySelector('[data-sort-input]');
    if (sortInput && sortInput.value) params.set('sort_by', sortInput.value);

    var qs = params.toString();
    window.location.href = window.location.pathname + (qs ? '?' + qs : '');
  }

  if (form) {
    form.querySelectorAll('[data-facet-checkbox]').forEach(function (cb) {
      cb.addEventListener('change', applyFilters);
    });
    form.querySelectorAll('[data-facet-price]').forEach(function (inp) {
      inp.addEventListener('change', applyFilters);
    });
    section.querySelectorAll('.filter-colour-swatch').forEach(function (sw) {
      sw.addEventListener('click', function () {
        sw.classList.toggle('is-selected');
        sw.setAttribute('aria-pressed', String(sw.classList.contains('is-selected')));
        applyFilters();
      });
    });
    section.querySelectorAll('.filter-sort-option').forEach(function (opt) {
      opt.addEventListener('click', function () {
        section.querySelectorAll('.filter-sort-option').forEach(function (o) {
          o.classList.remove('is-active'); o.setAttribute('aria-checked', 'false');
        });
        opt.classList.add('is-active'); opt.setAttribute('aria-checked', 'true');
        var sortInput = form.querySelector('[data-sort-input]');
        if (sortInput) sortInput.value = opt.getAttribute('data-sort-value');
        applyFilters();
      });
    });
    form.addEventListener('submit', function (e) { e.preventDefault(); applyFilters(); });
  }

  /* ---- Infinite scroll via Section Rendering API ---- */
  var grid = section.querySelector('[data-product-grid]');
  var loader = section.querySelector('[data-infinite-loader]');
  var sentinel = section.querySelector('[data-infinite-sentinel]');
  var loading = false;

  function loadMore() {
    if (loading || !sentinel) return;
    var nextUrl = sentinel.getAttribute('data-next-url');
    if (!nextUrl) return;
    loading = true;
    if (loader) loader.hidden = false;

    var fetchUrl = nextUrl + (nextUrl.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + sectionId;
    fetch(fetchUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('[data-product-grid]');
        if (newGrid) {
          Array.prototype.forEach.call(newGrid.children, function (child) {
            grid.appendChild(child.cloneNode(true));
          });
        }
        var newSentinel = doc.querySelector('[data-infinite-sentinel]');
        if (newSentinel && newSentinel.getAttribute('data-next-url')) {
          sentinel.setAttribute('data-next-url', newSentinel.getAttribute('data-next-url'));
        } else {
          if (observer) observer.disconnect();
          sentinel.removeAttribute('data-next-url');
          var end = document.createElement('p');
          end.className = 'collection-infinite__end';
          end.textContent = "You've reached the end of the collection";
          sentinel.parentNode.appendChild(end);
        }
        loading = false;
        if (loader) loader.hidden = true;
      })
      .catch(function () { loading = false; if (loader) loader.hidden = true; });
  }

  var observer = null;
  if (sentinel && 'IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) loadMore(); });
    }, { rootMargin: '400px 0px' });
    observer.observe(sentinel);
  }
})();
